module.exports = __webpack_public_path__ + "12_hair_brown.884350c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/12_hair_brown.png
// module id = 0ozH
// module chunks = 0